<template>
	<h2
		class="landing-subtitle"
		:class="{ 'landing-subtitle_uppercase': uppercase }"
		:style="customStyles"
		v-html="title"
		data-typo-type="subtitle"
	></h2>
</template>

<script>
export default {
	name: 'LandingSubtitle',
	props: {
		title: {
			type: String,
			required: true,
		},

		uppercase: {
			type: Boolean,
			default: false,
		},

		customStyles: {
			type: Object,
			default: () => ({}),
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-subtitle {
	text-align: center;
	margin: var(--size-16) 0;

	font-size: var(--size-16);
	line-height: var(--size-22);
	font-weight: 400;

	&_uppercase {
		text-transform: uppercase;
	}
}
</style>
